export default "__VITE_ASSET__Ctv5lkWD__"